/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {DropDownMenu, MenuItem} from "material-ui";
import getMuiTheme from "material-ui/styles/getMuiTheme";

import dashboardService from "../../services/dashboard-services";

class DomainCellRenderer extends Component {

    constructor(props, context) {
        super(props, context);
    }

    getChildContext() {
        return {muiTheme: getMuiTheme()};
    }

    handleChange(event, key, payload) {
        console.log(key, payload);

        if (payload === "Edit") {
            this.props.onOpenEditDialog(true, this.props.data, this.props.data.Domain);
        } else {
            this.props.onOpenDialog(true, this.props.data, payload, this.props.data.Domain);
        }
    }

    render() {
        let params = this.props;

        return (
            <div>
                <DropDownMenu
                    value={"Edit"}
                    onChange={this.handleChange.bind(this)}
                    style={{paddingLeft: 0}}
                    iconStyle={{top: "13px"}}
                    labelStyle={{paddingLeft: 0, lineHeight: "25px"}}
                    autoWidth={true}
                >
                    <MenuItem value={"Edit"} label={params.data.Domain} primaryText="Edit"/>
                    <MenuItem value={"Suspend"} label={params.data.Domain} primaryText="Suspend"/>
                    <MenuItem value={"Resume"} label={params.data.Domain} primaryText="Resume"/>
                    <MenuItem value={"Flush"} label={params.data.Domain} primaryText="Flush"/>
                    <MenuItem value={"Disable"} label={params.data.Domain} primaryText="Disable"/>
                    <MenuItem value={"Debug"} label={params.data.Domain} primaryText="Debug"/>
                </DropDownMenu>
            </div>
        )
    }
}


DomainCellRenderer.propTypes = {
    params: PropTypes.object
};

DomainCellRenderer.childContextTypes = {
    muiTheme: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    domain: state.dashboard.domain,
    saveStatus: state.dashboard.saveStatus,
});
const mapDispatchToProps = dispatch => ({
    onOpenDialog: (open, queue, action, domain) =>
        dispatch({type: 'OPEN_QUEUE_CONFIRM_DIALOG', payload: {open, queue, action, domain}}),
    onOpenEditDialog: (open, queue, action, domain) =>
        dispatch({type: 'OPEN_QUEUE_EDIT_DIALOG', payload: {open, queue, domain}})
});

DomainCellRenderer = connect(mapStateToProps, mapDispatchToProps)(DomainCellRenderer);

export default DomainCellRenderer;